import React, {useContext, useEffect, useRef, useState} from 'react';
import InputMask from "react-input-mask";
import {isComparePassword} from "../../../../../http/userAPI";
import {Context} from "../../../../../index";

const CompleteChangeNumber = (props) => {
    const [codeLimitErrorText, setCodeLimitErrorText] = useState('');
    const {main, basket} = useContext(Context);
    const session = main.basketSession;
    const mounted = useRef(false);
    const operation = useRef(0);
    useEffect(() => {
        mounted.current = true;
        return () => {mounted.current = false; operation.current += 1;};
    }, []);
    useEffect(() => {operation.current += 1; setCodeLimitErrorText('');}, [props.flowVersion]);

    const compareCode = async (code, newNumber, newCountry) => {
        const flow = props.getFlow();
        if (!mounted.current || !flow || props.controllClass !== 'active' || !/^\d{4}$/.test(code)) return false;
        const seq = ++operation.current;
        let ticket;
        try {ticket = props.startCompare(flow);}
        catch {setCodeLimitErrorText('Не удалось сменить номер. Попробуйте ещё раз.'); return false;}
        if (!ticket) return false;
        const current = () => mounted.current && operation.current === seq &&
            props.currentFlow(flow) && session.isCurrent(ticket);
        let tokenBranchSeen = false;
        const canCommitCurrentToken = () => {
            if (!current()) return false;
            tokenBranchSeen = true; return true;
        };
        props.clearCode();
        setCodeLimitErrorText('');
        let data;
        try {
            if (!current()) return false;
            data = await isComparePassword(code, flow.owner.id, newNumber,
                newCountry && typeof newCountry === 'object' ? {...newCountry} : newCountry,
                {canCommitToken: canCommitCurrentToken, commitContext: ticket});
        } catch {
            if (current() && props.failCompare(flow, ticket)) setCodeLimitErrorText('Не удалось сменить номер. Попробуйте ещё раз.');
            return false;
        }
        if (!current()) return false;
        if (!tokenBranchSeen || data?.error !== '' || !props.acceptCompare(flow, ticket, data?.jwt)) {
            if (props.failCompare(flow, ticket)) setCodeLimitErrorText('Не удалось сменить номер. Попробуйте ещё раз.');
            return false;
        }
        const acceptedEpoch = basket.sessionEpoch;
        const currentAccepted = () => mounted.current && operation.current === seq &&
            props.currentFlow(flow) && basket.sessionEpoch === acceptedEpoch;
        let refreshed;
        try {refreshed = await session.refresh();} catch {refreshed = {status: 'failed'};}
        if (!currentAccepted()) return false;
        if (refreshed.status !== 'accepted') {
            setCodeLimitErrorText('Номер изменён. Не удалось обновить корзину. Попробуйте ещё раз.');
            return true;
        }
        setCodeLimitErrorText(''); props.closeModalChangeNumber();
        return true;
    };


    return (
        <div className={"complete_change_number " + props.controllClass}>

            <div className={"contain_change_phone_close"}>
                <span className={"change_heading"}>Смена номера телефона</span>
                <button type="button" aria-label="Закрыть смену номера" style={{border: 0, background: 'transparent', padding: 0}}
                    onClick={e => props.closeModalChangeNumber()}
                    className={"close_modal_change_phone"}>

                </button>
            </div>
            <div className={"text_change_wrapper"}>
                <div className="text_change_container">

                    <p className={"text_change_p"}>Мы отправили Вам СМС на номер {props.newNumberNoValid}</p>
                    <p className={"text_change_p"}>Для подтверждения смены номера телефона - введите четырехзначный код в поле ниже. </p>
                    <div className={"container_change_mask"}>
                        <label htmlFor="change-phone-code" className={"title_change_input"}>Введите код из SMS</label>
                        <InputMask
                            id="change-phone-code"
                            className={"auth_sms_code"}
                            placeholder={"Код из SMS"}
                            mask={"9999"}
                            autoComplete={"one-time-code"}
                            value={props.smsCodeChangeNumber}
                            onChange={props.codeNumberValidator}
                            alwaysShowMask={false}
                            maskChar={"X"}
                        />
                        <div className={"code_limit_error"}>{codeLimitErrorText}</div>
                        <button type="button" style={{borderTop: 0, borderLeft: 0, borderRight: 0, background: 'transparent', padding: 0, fontFamily: 'inherit'}} className={"go_back_stage"} onClick={props.goToStateOne}>Указать другой номер</button>
                    </div>


                    <button type="button" style={{border: 0, fontFamily: 'inherit'}} disabled={props.controllClassConfirm !== 'active'} onClick={e => compareCode(props.smsCodeChangeNumber, props.newNumber, props.SelectCountryUser)} className={"change_and_check_number " + props.controllClassConfirm}>
                        Сменить
                    </button>

                </div>
            </div>







        </div>
    );
};

export default CompleteChangeNumber;
